module.exports = __webpack_public_path__ + "static/media/omdb.696366dc.png";